import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { StudentAccount, TeacherClass, Currency } from '@df/interfaces';
import { AccountService } from '@app/teacher/services/account.service';
import { declensionOfNumerals } from '@app/_utils/helpers';

import { closeIcon } from '@app/app.constants';

@Component({
    selector: 'app-class-account',
    templateUrl: './class-account.component.html',
    styleUrls: ['./class-account.component.scss']
})
export class ClassAccountComponent implements OnInit, OnDestroy {
    cameFromLesson = false;
    classAccounts: StudentAccount[];
    selectedStudent: StudentAccount;
    classInfo: TeacherClass;
    sumReward = 0;
    currency: Currency;
    currencyStr = '';
    today = new Date();
    selectedStudentIndex = 0;
    studentAccounts: StudentAccount[] = [];
    sortedStudents: Array<StudentAccount> = [];
    selectStudentCurrency = '';
    studentAmount = 0;
    closeIcon = closeIcon;
    lessonData: { subject: number; lesson: number };

    private selectedClassID: number;
    private destroy$ = new Subject<boolean>();

    constructor(private route: ActivatedRoute, private accountService: AccountService) {}

    public ngOnInit(): void {
        this.route.params.pipe(takeUntil(this.destroy$)).subscribe((params: Params) => {
            this.selectedClassID = +params['class_id'];
            this.getSumClassReward();
            this.getSelectedClass();
        });
        this.accountService.studentsUpdated.pipe(takeUntil(this.destroy$)).subscribe((students: StudentAccount[]) => {
            this.studentAccounts = students;
            this.selectStudentByParam();
        });
        this.accountService.studentSelected.pipe(takeUntil(this.destroy$)).subscribe((student: StudentAccount) => {
            this.selectedStudent = student;
        });
    }

    private getSelectedClass(): void {
        this.accountService
            .getClassAccounts(this.selectedClassID)
            .pipe(takeUntil(this.destroy$))
            .subscribe((studentClassAccounts: { accounts: StudentAccount[]; teacher_class: TeacherClass }) => {
                this.classAccounts = studentClassAccounts.accounts;
                this.accountService.setStudents(studentClassAccounts.accounts);
                this.classInfo = studentClassAccounts.teacher_class;
                this.sortingStudents();
            });
    }

    private selectStudentByParam() {
        /*
         * Этот метод помогает плавному переходу со страницы проведения на страницу банка выбранного ученика
         * */
        this.route.queryParams.pipe(takeUntil(this.destroy$)).subscribe((params: Params) => {
            if (params) {
                const index = +params['student'] - 1;
                if (index >= 0 && index < this.studentAccounts.length) {
                    this.lessonData = {
                        lesson: +params['lesson'],
                        subject: +params['subject']
                    };
                    this.cameFromLesson = true;
                    this.selectStudent(index);
                }
            }
        });
    }

    ngOnDestroy() {
        this.destroy$.next(true);
    }

    getSumClassReward() {
        this.accountService.getClassReward(this.selectedClassID).subscribe(resp => {
            if (resp) {
                this.sumReward = resp.reward;
                this.currency = resp.currency;
                this.currencyStr = declensionOfNumerals(resp.reward, resp.currency);
            }
        });
    }

    changeStudentReward(studentReward: number) {
        this.studentAmount = studentReward;
        this.selectStudentCurrency = declensionOfNumerals(this.studentAmount, this.currency);
    }

    deselectPupil() {
        this.selectedStudent = null;
        this.selectedStudentIndex = null;
    }

    sortingStudents() {
        this.sortedStudents = this.studentAccounts.sort((a, b) => {
            return a.student.surname.localeCompare(b.student.surname);
        });
    }

    backToTop() {
        let pos = document.body.scrollTop || window.pageYOffset;
        const timer = setInterval(() => {
            if (pos > 0) {
                window.scroll(0, (pos -= 5));
            } else {
                clearInterval(timer);
            }
        }, 5);
    }

    selectStudent(account): void {
        this.selectedStudent = account;
        this.studentAmount = Number(this.selectedStudent.amount);
        this.selectStudentCurrency = declensionOfNumerals(this.studentAmount, this.currency);
        this.accountService.studentSelected.next(this.selectedStudent);
        this.backToTop();
    }

    closeStudent() {
        this.selectedStudent = null;
    }
}
